import type { NotificationAdapter } from "./notification-adapter.interface";

export class NotificationAdapterFactory {
    private readonly adapters: NotificationAdapter[];

    constructor(adapters: NotificationAdapter[]) {
        this.adapters = adapters;
    }

    public create(payload: unknown): NotificationAdapter | null {
        const adapter = this.adapters.find((adapter) => adapter.canHandle(payload));
        return adapter ?? null;
    }

    public process(payload: unknown): void {
        const adapter = this.create(payload);
        if (adapter) {
            adapter.process(payload);
        }
    }
}
